/**
 * 搜索轮次的当前执行步骤枚举
 * @description 表示搜索轮次当前执行到的步骤
 */
export enum CurrentStep {
    /** 查询步骤 */
    Query = -1,
    /** 筛选步骤1 (R1) */
    FilterStep1 = 0,
    /** 筛选步骤2 (R2) */
    FilterStep2 = 1,
    /** 筛选步骤3 (R3) */
    FilterStep3 = 2,
    /** 最终展示步骤 */
    Final = 3,
}

export enum PatentRiskLevel {
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
}
